// The sales report's words in English, by key: the fallback of the CMS
// TextBundle "store_sales" (./useSalesTexts.js), and what it is seeded from.
export default {
  fields: "Fields",
  choose_the_fields_shown: "Choose the fields shown",
  fields_of_the_chart: "Fields of the chart",
  columns_of_the_table: "Columns of the table",
  reset: "Reset",
  done: "Done",
  gross_sales: "Gross sales",
  net_sales: "Net sales",
  delivery_refunds: "Delivery refunds",
  delivery: "Delivery",
  // a vendor's report only (the API answers them for one organization)
  commission: "Commission",
  earnings: "Earnings",
  n_more: "+%s more",
  aggregate_by: "Aggregate by",
  all_products: "All products",
  by_day_of_the_month: "By day of the month",
  by_day_of_the_week: "By day of the week",
  by_hour_of_the_day: "By hour of the day",
  by_month_of_the_year: "By month of the year",
  by_quarter_of_the_year: "By quarter of the year",
  by_year: "By year",
  clear_selection_n: "Clear selection (%s)",
  conversion: "Conversion",
  custom_range: "Custom Range",
  day: "day",
  days: "Days",
  days_begin_at_midnight_in_n: "Days begin at midnight in %s",
  group_the_period: "Group the period",
  groups: "Groups",
  hide_n_from_the_chart: "Hide %s from the chart",
  hour: "hour",
  hours: "Hours",
  last_24_hours: "Last 24 Hours",
  last_30_days: "Last 30 Days",
  last_365_days: "Last 365 Days",
  last_7_days: "Last 7 Days",
  last_90_days: "Last 90 Days",
  lifetime: "Lifetime",
  loading: "Loading…",
  month: "month",
  months: "Months",
  no_data_available: "No data available",
  off_a_line_through_time: "Off: a line through time",
  proceeds: "Proceeds",
  product: "Product",
  products: "Products",
  quarter: "quarter",
  quarters: "Quarters",
  refunded: "Refunded",
  remove_n: "Remove %s",
  remove_n_from_the_selection: "Remove %s from the selection",
  sales: "Sales",
  search_products: "Search products…",
  selected_only: "Selected only",
  show_n_on_the_chart: "Show %s on the chart",
  show_less: "Show less",
  too_long_a_range_for_n_shown_by_n: "Too long a range for %s — shown by %s",
  units: "Units",
  views: "Views",
  week: "week",
  weeks: "Weeks",
  year: "year",
  years: "Years",
}
